import { AlertTriangle } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "utils";

/**
 * The calm warning box: a status-coloured hairline and a 15 percent wash of the
 * status colour over the surface, with ordinary text. A flat warning fill is a
 * bright yellow slab on Dusk, and the text on it would not follow the theme.
 */
export const WARNING_BOX =
  "rounded-md border border-status-warning bg-status-warning/15 px-3 py-2 text-sm text-foreground";

/** A warning with its icon, so the meaning does not rest on colour alone. */
export function WarningNote({
  children,
  role = "status",
  testId,
  className,
}: {
  children: ReactNode;
  /**
   * "none" for a note that holds buttons or changes in place: a live region
   * re-reads all of it on every change, so the caller announces the short
   * part that matters through its own region instead.
   */
  role?: "status" | "alert" | "none";
  testId?: string;
  className?: string;
}) {
  return (
    <div
      role={role}
      className={cn("flex items-start gap-2", WARNING_BOX, className)}
      data-testid={testId}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <span className="min-w-0">{children}</span>
    </div>
  );
}
